import { Button, Card, Group, Text, Stack, CopyButton, Tooltip, ActionIcon, rem } from "@mantine/core"
import { useNavigate, useParams } from "@tanstack/react-router"
import { ChangeUserPassword } from "./ChangeUserPassword";
import { PageTitle } from "@/Components/PageTitle";
import { getApiAdminUserManagerGetUser, useGetApiAdminUserManagerGetUser } from "@/API";
import { IconCopy, IconEdit } from "@tabler/icons-react";
import { ChangeUserDisplayNameButton } from "./ChangeUserDisplayName";
import { ChatCreditKeyList } from "./ChatCreditKey";

export function UserInfo() {
    const navigate = useNavigate()
    const { userId } = useParams({ from: "/admin/userManager/$userId" })
    const user = useGetApiAdminUserManagerGetUser({ userId: userId })
    return <>
        <PageTitle text="使用者資料" />
        <Group gap={20}>
            <Text fw={500} size="xl">
                使用者ID
            </Text>
            <Group gap={0}>
                <Text fw={500} size="xl">
                    {userId}
                </Text>
                <CopyButton value={userId ?? ""}>
                    {({ copied, copy }) => (
                        <Tooltip label={copied ? '已複製' : ''} disabled={!copied} withArrow>
                            <ActionIcon size="xl" variant="transparent" onClick={copy}>
                                <IconCopy style={{ width: rem(24), height: rem(24) }} />
                            </ActionIcon>
                        </Tooltip>
                    )}
                </CopyButton>
            </Group>
        </Group>
        <Group gap={20}>
            <Text fw={500} size="xl">
                使用者帳號
            </Text>
            <Group gap={0}>
                <Text fw={500} size="xl">
                    {user.data?.data.userName}
                </Text>
                <CopyButton value={user.data?.data.userName ?? ""}>
                    {({ copied, copy }) => (
                        <Tooltip label={copied ? '已複製' : ''} disabled={!copied} withArrow>
                            <ActionIcon size="xl" variant="transparent" onClick={copy}>
                                <IconCopy style={{ width: rem(24), height: rem(24) }} />
                            </ActionIcon>
                        </Tooltip>
                    )}
                </CopyButton>
            </Group>
        </Group>
        <Group gap={20}>
            <Text fw={500} size="xl">
                顯示名稱
            </Text>
            <Group gap={0}>
                <Text fw={500} size="xl">
                    {user.data?.data.displayName && user.data?.data.displayName != "" ? user.data?.data.displayName : "無"}
                </Text>
                <ChangeUserDisplayNameButton userId={userId} initialValue={user.data?.data.displayName ?? ""}>
                    <ActionIcon
                        size="xl"
                        variant="transparent"
                    >
                        <IconEdit />
                    </ActionIcon>
                </ChangeUserDisplayNameButton>
            </Group>
        </Group>

        <Stack mt={10}>
            <PageTitle text="管理" />
            <ChangeUserPassword userId={userId} />
        </Stack>
        <Stack mt={10}>
            <PageTitle text="聊天點數管理" />
            <ChatCreditKeyList userId={userId} />
        </Stack>
    </>
}